// src/ai/HostTemplates.js
export function introLine({ q, displayNumber }) {
  const raw = String(q?.question || "").trim()
    .replace(/^\{B\}\s*/i, "")
    .replace(/^\{Q(?:,TXT|,NUM)?\}\s*/i, "")
    .replace(/^\{TXT\}\s*/i, "")
    .replace(/^\{NUM\}\s*/i, "")
    .replace(/^\{E\}\s*/i, "")
    .replace(/\{LB\}/gi, " ");
  const t = String(q?.type || "").toUpperCase();
  if (t === "STARTROUND") return `Starting a new round. ${raw}`;
  if (t === "ENDROUND")   return `That’s the end of the round. ${raw}`;
  if (t === "DISPLAY" || t === "SLIDE" || t.includes("DEFAULT")) return raw;
  const prefix = displayNumber > 0 ? `Question ${displayNumber}. ` : "";
  return `${prefix}${raw}`;
}

export function timesUp({ q, answersIn = 0, examples = [] }) {
  const T = String(q?.type || "").toUpperCase();
  if (T === "NEARESTANSWER") return "Time’s up. Let’s see who was closest.";
  if (T === "WHEEL") return "Time’s up. Reveal the board.";
  if (answersIn === 0) return "Time’s up. No answers received.";
  if (examples.length) return `Time’s up. Answers in from ${examples.join(", ")}.`;
  return "Time’s up.";
}

export function scoreBump({ top, movers = [] }) {
  if (!top?.length) return "";
  const leader = top[0];
  const line = `Leaderboard: ${leader.team} on ${leader.points}.`;
  if (movers.length) {
    return `${line} Movers: ${movers.map(m => m.team).slice(0,3).join(", ")}.`;
  }
  return line;
}
